// extracted by mini-css-extract-plugin
module.exports = {"rich-message":"rich-message--3vmJD5xq","rich-message-no-icon":"rich-message-no-icon--3Et3-gen"};